import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`
export default {
    // 群发列表
    getList: {
        url: `${customerApi}/api/mass_sending/{id}/user_details`,
        type: 'GET',
    },
}
